import { BlogBody } from "./BlogBody";
import { BlogHero } from "./BlogHero";
import { BlogHeroImage } from "./BlogHeroImage";
import { MarketingPageLayout } from "../components/MarketingPageLayout";
import { BottomCTA } from "../sections/BottomCTA";

export function BlogPage() {
  return (
    <MarketingPageLayout current="blog">
      <BlogHero />
      <BlogHeroImage />
      <BlogBody />
      <BottomCTA />
    </MarketingPageLayout>
  );
}
